






















































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import Table from '@/components/Table.vue';
import moment from 'moment';
import SimService from '@/services/sim.service';
import {Getter} from 'vuex-class';
import Dialog from '@/components/Dialog.vue';
import SimProductForm from '@/components/subscriptions/SimProductForm.vue';
import {SimProduct, SubscriptionProduct} from '@/types';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    GenericButton,
    SimProductForm,
    Dialog,
    Table,
  },
})
export default class SimProducts extends Vue {
  @Getter private hasPermission: any;
  private showProductDialog: boolean = false;
  private selectedProduct: SimProduct | null = null;
  private networkOperators: Array<{[ key: string ]: string}> = [];
  private formFactors: Array<{[ key: string ]: string}> = [];
  private products: SimProduct[] = [];
  private dataTableHeight: number = 100;
  private search: string = '';
  private editing: boolean = false;
  private headers: Array<{[ key: string ]: string | boolean}> = [
    { text: 'Product code', value: 'product_code', sortable: true, filterable: true },
    { text: 'Name', value: 'name', sortable: false, filterable: true },
    { text: 'Provider', value: 'network_operator_id', sortable: false },
    { text: 'Form factor', value: 'sim_form_factors', sortable: false },
    { text: 'Type', value: 'type', sortable: false },
    { text: 'Description', value: 'description', sortable: false },
    { text: 'Activation period (days)', value: 'activation_period', sortable: false },
    { text: '', value: 'actions', sortable: false, align: 'end' },
  ];

  private mounted() {
    Promise.all([
      this.getFormFactors(),
      this.getNetworkOperators(),
      this.getSimProducts(),
    ]);
  }

  private updateDataTableHeight() {
    this.dataTableHeight = (this.$refs.productCard as any).$el.clientHeight;
  }

  private async getFormFactors() {
    const formFactors = await SimService.getFormFactors();
    Vue.set(this, 'formFactors', formFactors);
  }

  private async getNetworkOperators() {
    const networkOperators = await SimService.getNetworkOperators();
    Vue.set(this, 'networkOperators', networkOperators);
  }

  private async getSimProducts() {
    const products = await SimService.getSimProducts();
    Vue.set(this, 'products', products);
  }

  private getName(networkId: number) {
    const networkOperator = this.networkOperators.find((p) => Number(p.id) === Number(networkId));
    return networkOperator ? networkOperator.name : '';
  }

  private async handleRowClicked(row: any) {
    this.editing = true;
    Vue.set(this, 'selectedProduct', {...row});
    this.showProductDialog = true;
  }

  private add() {
    this.selectedProduct = { activation_period: 365 } as SimProduct;
    this.showProductDialog = true;
  }
}
